/***********************************************************
 Vuex Profile Manage Store
 --------------------------
 Store to share common data between the "my/profile/manage" pages.
 ************************************************************/
import {defineStore} from 'pinia'

export const useManageStore = defineStore('manage', {
    state: () => ({
        /**
         * The data of the user to manage.
         */
        user: {} as object
    }),

    actions: {

        async refreshUser(userKey: string|number = 'my') {
            const {$apiFetch, $auth} = useNuxtApp();
            if (userKey === 'my' && !$auth.loggedIn) {
                this.user = {};
                return;
            }

            const {data} = await $apiFetch(`/v1/views/users/${userKey}/manage`);
            this.user = data;
        },

        /**
         * Reloads the data of the currently logged user, if the logged user is the same es the store user.
         */
        async reloadLoggedUserDataIfSameUser() {
            const {$auth} = useNuxtApp();

            if (this.user.id === $auth.user.id) {
                await $auth.fetchUser();
            }
        },

        /**
         * Handles post update actions by refreshing the store user data as well as the auth user data if the logged user is the same as the store user.
         */
        async handleUpdated() {
            await Promise.all([
                this.reloadLoggedUserDataIfSameUser(),
                this.refreshUser()
            ])
        },
    }

});